export function Hero() {
  return `
    <section class="hero">
      <div class="hero__bg"></div>
      <div class="hero__content">
        <div class="hero__content-text">
          <h1 class="hero__title text-xl font-medium">Reach Your Best Forma</h1>
          <p class="hero__desc text-base font-medium">
            Prenota una consulenza gratuita con il nostro team: un momento dedicato all’ascolto, alla valutazione e alla definizione dei tuoi obiettivi.<br/>
            Un’esperienza su misura, pensata per comprendere le tue esigenze e costruire insieme il percorso più adatto a te.
          </p>
          <a href="https://calendar.app.google/1JjTCQx96w6tuZjq9" class="btn__primary" target="_blank">Prenota una consulenza</a>
        </div>
      </div>
    </section>
  `;
} 